// @ts-ignore
import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { MessagesProps } from 'antd-notifications-messages'

import { IOrderDetails } from '@/ducks/orders/orders.types'
import { removeFromLocalStorage } from '@/services/localStorage'

type INotificationIntent = 'success' | 'error' | 'warning' | 'info'
interface IToast {
  duration?: number
  dismissible?: boolean
  type?: 'system' | 'newOrder'
  message?: string
  orderDetails?: IOrderDetails & { earnings: number }
  intent?: INotificationIntent
}

interface INotification extends IToast {
  id: number
}

export interface NotificationsState {
  notifications: MessagesProps[]
  system: INotification[]
  newOrders: INotification[]
  toastCounter: number
}

const initialState: NotificationsState = {
  notifications: [],
  newOrders: [],
  system: [],
  toastCounter: 0
}

const notificationsSlice = createSlice({
  name: 'notifications',
  initialState,
  reducers: {
    /** @deprecated use addNotificationNew */
    addNotification: (state, action: PayloadAction<MessagesProps>) => {
      state.notifications = [...state.notifications, action.payload]
    },
    /** @deprecated use removeNotificationNew */
    removeNotification: state => {
      state.notifications = state.notifications.slice(1)
    },

    addSystemNotification: (state, action: PayloadAction<IToast>) => {
      state.system.push({
        ...action.payload,
        type: 'system',
        id: state.toastCounter + 1
      })
      state.toastCounter += 1
    },

    addNewOrderNotification: (state, action: PayloadAction<IToast>) => {
      state.newOrders.push({
        ...action.payload,
        type: 'newOrder',
        id: state.toastCounter + 1
      })
      state.toastCounter += 1
    },

    removeNotificationNew: (state, action: PayloadAction<number>) => {
      const filterById = (notification: INotification) =>
        notification.id !== action.payload

      state.system = state.system.filter(filterById)
      state.newOrders = state.newOrders.filter(filterById)
    },

    clearOrderNotifications: state => {
      state.newOrders = []
      removeFromLocalStorage('orderNotifications')
    }
  }
})

export const {
  addSystemNotification,
  removeNotification,
  addNotification,
  addNewOrderNotification,
  removeNotificationNew,
  clearOrderNotifications
} = notificationsSlice.actions

export type { INotification, INotificationIntent, IToast }

export default notificationsSlice.reducer
